// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"d518a7d0","1634":"b7915baa","3558":"235ef66d","5051":"882673d6","7098":"d87de60e"}[chunkId] + ".chunk.css";
};